import { render } from "./Money.vue?vue&type=template&id=4c895250"
import script from "./Money.vue?vue&type=script&setup=true&lang=js"
export * from "./Money.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Table/Fields/Money.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c895250"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c895250', __exports__)) {
    api.reload('4c895250', __exports__)
  }
  
  module.hot.accept("./Money.vue?vue&type=template&id=4c895250", () => {
    api.rerender('4c895250', render)
  })

}


export default __exports__